import { useQuery } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface VendorQuestionsData {
  questions: string[];
  confidence: string;
}

export interface VendorQuestionsResponse {
  success: boolean;
  data: VendorQuestionsData | null;
  message?: string;
}

interface EnrichmentParams {
  query: string;
  service_type: string;
  location: string;
  requirements?: string;
}

export const useGetVendorQuestions = (
  params: EnrichmentParams,
  enabled = false
) => {
  const { session } = useAuth();

  return useQuery({
    queryKey: ['vendor-questions', params.query, params.service_type, params.location],
    queryFn: async () =>
      handleApiCall<VendorQuestionsResponse, EnrichmentParams>(
        session,
        'POST',
        'vendor/enrichments/vendor-questions',
        params
      ),
    enabled,
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
};
